import { render, staticRenderFns } from "./CreatePostalCode.vue?vue&type=template&id=73f92175"
import script from "./CreatePostalCode.vue?vue&type=script&lang=js"
export * from "./CreatePostalCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports